import * as React from "react";
import { VoucherState } from "../../../services/voucher";
import { VoucherCard, VoucherContainer, VoucherItem } from "./styles";
import ImageView from "../../../components/SmartImage";
import { isNotBlankArray } from "../../../utils/array";
import styled from "styled-components";
const VoucherContainerWrap = styled(VoucherContainer) `
	/* height: 169px; */
`;
const VoucherItemTwo = styled(VoucherItem) `
	width: 1038px;
	justify-content: space-between;
`;
const ImageViewWrap = styled.div `
	flex: 1;
`;
export const VoucherCardTwo = styled(VoucherCard) `
	display: flex;
	width: 49%;
	min-height: 145px;

	&.expired {
		.voucherImg {
			filter: grayscale(100%);
			opacity: 0.8;
		}
		& > .controllerArea {
			background-color: #ddd !important;
			color: #6e6e6e !important;
			cursor: default;
		}
	}

	.voucherImg {
		width: 100%;
		height: auto;
		display: block;
	}

	& > .stamp {
		left: 267px;
		width: 135px;
		height: 100%;
	}

	& > i {
		top: calc(50% - 13px);
	}

	.controllerArea {
		width: 175px;
		font-size: 18px;
		font-weight: 800;
		text-align: center;
		cursor: pointer;
	}
`;
export default class VoucherTwo extends React.Component {
    constructor() {
        super(...arguments);
        this.renderVoucherCom = (voucher, index) => {
            var _a;
            const { online, onClaimVoucher, callbackText, icon, baseColor } = this.props;
            const { ui, img, voucherState, link, voucherId, height } = voucher;
            const isExhaust = voucher.voucherState === VoucherState.ComingSoon;
            const isExpired = voucher.voucherState === VoucherState.Expired;
            const isClaimed = voucher.voucherState === VoucherState.RanOut;
            return (React.createElement(VoucherCardTwo, { className: `${isExhaust || isExpired ? "expired" : ""}`, key: `${voucherId}_${index}` },
                React.createElement("img", { src: icon, className: "stamp", style: { display: isClaimed ? "block" : "none" }, alt: "" }),
                React.createElement(ImageViewWrap, null,
                    React.createElement(ImageView, { src: img || "", imgClass: "voucherImg", isLazyLoad: true, aliSize: 4, online: online, style: { height } })),
                React.createElement("div", { className: "controllerArea", style: { backgroundColor: ui === null || ui === void 0 ? void 0 : ui.bgColor, color: (_a = ui === null || ui === void 0 ? void 0 : ui.colorTable) === null || _a === void 0 ? void 0 : _a.textColor } },
                    React.createElement("a", { onClick: () => onClaimVoucher(voucher) }, callbackText(voucherState, !!link))),
                React.createElement("i", { className: "dotLeft", style: { backgroundColor: baseColor || "#f7f7f7" } }),
                React.createElement("i", { className: "dotRight", style: { backgroundColor: baseColor || "#f7f7f7" } })));
        };
    }
    render() {
        const { vouchers, positionId } = this.props;
        const hasValidVoucher = isNotBlankArray(vouchers);
        return (React.createElement(React.Fragment, null, hasValidVoucher && (React.createElement(VoucherContainerWrap, { id: positionId },
            React.createElement(VoucherItemTwo, null, vouchers.map((item, index) => this.renderVoucherCom(item, index)))))));
    }
}
